import { createFleetHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/FleetHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const deleteFleetUseCase = async (
  id: string,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createFleetHttpRepository(tokenProvider);
  await repository.delete(id);
};
